document.addEventListener('DOMContentLoaded', function() {
  // Aguardar o Swiper estar disponível
  if (typeof Swiper === 'undefined') {
    console.error('Swiper não está carregado. Verifique se o Swiper está incluído no theme.liquid');
    return;
  }

  // Buscar todos os carrosséis de depoimentos na página
  const testimonialCarousels = document.querySelectorAll('.testimonials-carousel-swiper');
  
  testimonialCarousels.forEach(function(carousel) {
    // Obter configurações do data-attributes
    const carouselId = carousel.id;
    const columnsDesktop = parseInt(carousel.dataset.columnsDesktop) || 3;
    const columnsMobile = parseInt(carousel.dataset.columnsMobile) || 1;
    const spacing = parseInt(carousel.dataset.space) || 20;
    const autoplay = carousel.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(carousel.dataset.speed) || 5;
    const pauseOnHover = carousel.dataset.pauseOnHover === 'true';
    const effect = carousel.dataset.effect || 'slide';
    
    // Configuração base do Swiper
    const swiperConfig = {
      loop: true,
      spaceBetween: spacing,
      centeredSlides: false,
      grabCursor: true,
      
      // Configuração de colunas responsivas
      slidesPerView: columnsMobile,
      breakpoints: {
        750: {
          slidesPerView: Math.min(2, columnsDesktop),
          spaceBetween: spacing
        },
        990: {
          slidesPerView: columnsDesktop,
          spaceBetween: spacing
        }
      }
    };
    
    // Adicionar efeito de transição
    if (effect !== 'slide') {
      swiperConfig.effect = effect;
      
      // Configurações específicas para cada efeito
      switch(effect) {
        case 'fade':
          swiperConfig.fadeEffect = {
            crossFade: true
          };
          swiperConfig.slidesPerView = 1;
          swiperConfig.breakpoints = {};
          break;
          
        case 'coverflow':
          swiperConfig.coverflowEffect = {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          };
          break;
          
        case 'cube':
          swiperConfig.cubeEffect = {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          };
          swiperConfig.slidesPerView = 1;
          swiperConfig.breakpoints = {};
          break;
      }
    }
    
    // Adicionar autoplay se habilitado
    if (autoplay) {
      swiperConfig.autoplay = {
        delay: autoplaySpeed * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover
      };
    }
    
    // Adicionar navegação se existir
    const prevButton = carousel.querySelector('.swiper-button-prev');
    const nextButton = carousel.querySelector('.swiper-button-next');
    if (prevButton && nextButton) {
      swiperConfig.navigation = {
        prevEl: prevButton,
        nextEl: nextButton
      };
    }
    
    // Adicionar paginação se existir
    const pagination = carousel.querySelector('.swiper-pagination');
    if (pagination) {
      swiperConfig.pagination = {
        el: pagination,
        clickable: true,
        dynamicBullets: true
      };
    }
    
    // Adicionar suporte para teclado
    swiperConfig.keyboard = {
      enabled: true,
      onlyInViewport: true
    };
    
    // Adicionar suporte para acessibilidade
    swiperConfig.a11y = {
      enabled: true,
      prevSlideMessage: 'Depoimento anterior',
      nextSlideMessage: 'Próximo depoimento',
      firstSlideMessage: 'Este é o primeiro depoimento',
      lastSlideMessage: 'Este é o último depoimento',
      paginationBulletMessage: 'Ir para depoimento {{index}}',
      notificationClass: 'swiper-notification'
    };
    
    // Configurar velocidade de transição
    swiperConfig.speed = 600;
    
    // Configurar observação de mudanças no DOM
    swiperConfig.observer = true;
    swiperConfig.observeParents = true;
    swiperConfig.observeSlideChildren = true;
    
    // Configurar atualização automática ao redimensionar
    swiperConfig.resizeObserver = true;
    swiperConfig.updateOnWindowResize = true;
    
    // Adicionar lazy loading para imagens
    swiperConfig.lazy = {
      loadPrevNext: true,
      loadPrevNextAmount: 1
    };
    
    // Inicializar o Swiper
    try {
      const swiper = new Swiper(`#${carouselId}`, swiperConfig);
      
      // Adicionar classe quando carregado
      carousel.classList.remove('is-loading');
      
      // Pausar/retomar autoplay manualmente se configurado
      if (autoplay && pauseOnHover) {
        carousel.addEventListener('mouseenter', function() {
          if (swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.pause();
          }
        });
        
        carousel.addEventListener('mouseleave', function() {
          if (swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.resume();
          }
        });
      }
      
      // Adicionar suporte para touch em dispositivos móveis
      let touchStartX = 0;
      let touchEndX = 0;
      
      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
      });
      
      carousel.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipeGesture();
      });
      
      function handleSwipeGesture() {
        if (touchEndX < touchStartX - 50) {
          swiper.slideNext();
        }
        if (touchEndX > touchStartX + 50) {
          swiper.slidePrev();
        }
      }
      
      // Atualizar Swiper quando a janela redimensionar
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
          swiper.update();
        }, 250);
      });
      
      // Verificar se há imagens lazy e forçar carregamento da primeira
      const lazyImages = carousel.querySelectorAll('img[loading="lazy"]');
      if (lazyImages.length > 0) {
        lazyImages.forEach(function(img, index) {
          if (index < columnsDesktop) {
            img.loading = 'eager';
          }
        });
      }
      
    } catch (error) {
      console.error('Erro ao inicializar o Swiper para depoimentos:', error);
    }
  });
  
  // Função helper para verificar se o elemento está visível
  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  // Iniciar autoplay apenas quando visível (performance)
  let isVisible = false;
  
  function checkVisibility() {
    testimonialCarousels.forEach(function(carousel) {
      if (isElementInViewport(carousel)) {
        if (!isVisible) {
          isVisible = true;
          // Pode adicionar lógica adicional aqui se necessário
        }
      } else {
        isVisible = false;
      }
    });
  }
  
  // Verificar visibilidade ao rolar
  window.addEventListener('scroll', checkVisibility);
  window.addEventListener('resize', checkVisibility);
  
  // Verificar visibilidade inicial
  checkVisibility();
});
